import { render } from "./MainGianHang.vue?vue&type=template&id=54ad2bda"
import script from "./MainGianHang.vue?vue&type=script&lang=js"
export * from "./MainGianHang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__